import { render, staticRenderFns } from "./ProgramProfile.vue?vue&type=template&id=0ecd45c8"
import script from "./ProgramProfile.vue?vue&type=script&lang=ts"
export * from "./ProgramProfile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports